__turbopack_context__.v({
  "body-r1": "Text-module-scss-module__OXdc6a__body-r1",
  "body-r2": "Text-module-scss-module__OXdc6a__body-r2",
  "body-r3": "Text-module-scss-module__OXdc6a__body-r3",
  "body-r4": "Text-module-scss-module__OXdc6a__body-r4",
  "button-m1": "Text-module-scss-module__OXdc6a__button-m1",
  "button-m2": "Text-module-scss-module__OXdc6a__button-m2",
  "button-m3": "Text-module-scss-module__OXdc6a__button-m3",
  "button-m4": "Text-module-scss-module__OXdc6a__button-m4",
  "button-sb1": "Text-module-scss-module__OXdc6a__button-sb1",
  "button-sb2": "Text-module-scss-module__OXdc6a__button-sb2",
  "button-sb3": "Text-module-scss-module__OXdc6a__button-sb3",
  "button-sb4": "Text-module-scss-module__OXdc6a__button-sb4",
  "caption-m1": "Text-module-scss-module__OXdc6a__caption-m1",
  "caption-m2": "Text-module-scss-module__OXdc6a__caption-m2",
  "caption-m3": "Text-module-scss-module__OXdc6a__caption-m3",
  "caption-sb1": "Text-module-scss-module__OXdc6a__caption-sb1",
  "caption-sb2": "Text-module-scss-module__OXdc6a__caption-sb2",
  "caption-sb3": "Text-module-scss-module__OXdc6a__caption-sb3",
  "display-eb1": "Text-module-scss-module__OXdc6a__display-eb1",
  "display-eb2": "Text-module-scss-module__OXdc6a__display-eb2",
  "display-eb3": "Text-module-scss-module__OXdc6a__display-eb3",
  "heading-m1": "Text-module-scss-module__OXdc6a__heading-m1",
  "heading-m2": "Text-module-scss-module__OXdc6a__heading-m2",
  "heading-m3": "Text-module-scss-module__OXdc6a__heading-m3",
  "heading-sb1": "Text-module-scss-module__OXdc6a__heading-sb1",
  "heading-sb2": "Text-module-scss-module__OXdc6a__heading-sb2",
  "heading-sb3": "Text-module-scss-module__OXdc6a__heading-sb3",
  "text": "Text-module-scss-module__OXdc6a__text",
  "title-b1": "Text-module-scss-module__OXdc6a__title-b1",
  "title-b2": "Text-module-scss-module__OXdc6a__title-b2",
  "title-b3": "Text-module-scss-module__OXdc6a__title-b3",
  "title-m1": "Text-module-scss-module__OXdc6a__title-m1",
  "title-m2": "Text-module-scss-module__OXdc6a__title-m2",
  "title-m3": "Text-module-scss-module__OXdc6a__title-m3",
  "wrap": "Text-module-scss-module__OXdc6a__wrap",
});
